<ng-container
  *ngIf="
    !isP10MCustomer &&
    productDetails &&
    productName !== '' &&
    !productDetails?.isEpin() &&
    !isTouristSimkit &&
    displayAccessoriesSection
  "
>
  <!-- <hr *ngIf="!isWebChannel" class="divider"> -->
  <div class="row">
    <div class="col-12">
      <div *ngIf="isCartLanding; else elseBlock">
        <h3 class="m-t-xl">{{ configurableContent?.accessories }}</h3>
        <p class="lead m-t-lg" *ngIf="!productExists; else deviceAvailable">
          {{ configurableContent?.wantToAddAccessories }}
        </p>
        <ng-template #deviceAvailable>
          <p class="lead m-t-lg">
            {{ configurableContent?.noAccessories }}
            <span *ngIf="!moreThanOneDevice">{{ familyName }}!</span>
            <span *ngIf="moreThanOneDevice">{{ configurableContent?.device }}</span>
          </p>
        </ng-template>
        <p class="m-t-md lead">
          <a
            href="javascript:void(0)"
            id="accessory-section-cart-landing-add-accessroy-link"
            tabindex="{{ productExists || !isLineSetupCompleted ? -1 : 0 }}"
            [attr.aria-label]="configurableContent?.addAccessories"
            (click)="navigateToAccessories()"
            >{{ configurableContent?.addAccessories }}</a
          >
        </p>
      </div>
      <ng-template #elseBlock>
        <div>
          <h3 class="m-t-xl">{{ configurableContent?.accessories }}</h3>
          <p class="lead m-t-lg">
            {{ configurableContent?.noAccessories }}
            <span
              *ngIf="productName && (deviceLanding || (productSelectorLanding && productExists))"
              >{{ productName }}!</span
            >
            <span *ngIf="!productExists && productSelectorLanding">{{
              configurableContent?.device
            }}</span>
            <span *ngIf="byodSimData">{{ configurableContent?.device }}!</span>
          </p>
        </div>
        <p class="m-t-md lead">
          <a
            href="javascript:void(0)"
            id="accessory-section"
            [class.disabled]="
              !byodSimData && productExists && !isLineSetupCompleted && !deviceLanding
            "
            tabindex="{{ productExists || !isLineSetupCompleted ? -1 : 0 }}"
            [attr.aria-label]="configurableContent?.addAccessories"
            (click)="navigateToAccessories()"
            >{{ configurableContent?.addAccessories }}</a
          >
        </p>
      </ng-template>
    </div>
  </div>
</ng-container>
